import App from './components/App';
import home from './routes/home';
import games from './routes/games';
import organizations from './routes/organizations';
import players from './routes/players';
import sessions from './routes/sessions';
import getCodings from './modules/coding/actions/getCodings';
import getScores from './modules/scores/actions/getScores';
import SignIn from './SignIn';

export default store => ({
  childRoutes: [
    {
      path: '/games/:gameId/code',
      getComponent: (nextState, callback) => {
        require.ensure([], require =>
          callback(
            null,
            require('./routes/games/containers/CodingContainer').default
          )
        );
      },
      onEnter({ params: { gameId } }) {
        store.dispatch(getCodings(gameId));
        store.dispatch(getScores(gameId));
      }
    },
    {
      path: '/',
      component: App,
      indexRoute: { onEnter: (nextState, replace) => replace('/home') },
      childRoutes: [
        home(store),
        games(store),
        organizations(store),
        players(store),
        sessions(store)
      ]
    },
    {
      path: '/sign-in',
      component: SignIn
    }
  ]
});



// WEBPACK FOOTER //
// ./src/routes.js